import {
    faEnvelope,
    faList,
    faMobile,
    faNote,
    faPenField,
    faTag,
} from '@fortawesome/pro-solid-svg-icons';
import { WorkflowActionTypeEnum } from 'constants/workflows';

const getActionNodeHeaderDetails = (type: WorkflowActionTypeEnum) => {
    switch (type) {
        case WorkflowActionTypeEnum.ADD_NOTE:
            return {
                icon: faNote,
                text: 'Add note to contact',
            };
        case WorkflowActionTypeEnum.SEND_EMAIL:
            return {
                icon: faEnvelope,
                text: 'Send email',
            };
        case WorkflowActionTypeEnum.SEND_SMS:
            return {
                icon: faMobile,
                text: 'Send text',
            };
        case WorkflowActionTypeEnum.SET_CUSTOM_FIELD:
            return {
                icon: faPenField,
                text: 'Set custom field value',
            };
        case WorkflowActionTypeEnum.CONTACT_TAG:
            return {
                icon: faTag,
                text: 'Tag contact',
            };
        case WorkflowActionTypeEnum.CONTACT_UNTAG:
            return {
                icon: faTag,
                text: 'Untag contact',
            };
        case WorkflowActionTypeEnum.TASK_CREATE:
            return {
                icon: faList,
                text: 'Create task',
            };
    }
};

export { getActionNodeHeaderDetails };
